<app-scroll-spy-menu></app-scroll-spy-menu>

<app-default-card
  spyTarget="inbetriebnahmeData"
  [title]="'Daten der Netzanmeldung'"
  [info]="'Bitte überprüfen Sie die hier angegebenen Informationen'"
  [showThisComponent]="true"
  [showChildComponent]="gridRegistrationDto">
  <section>
    <app-connection-object-summary
      [connectionObject]="gridRegistrationDto?.connectionObject"
      [connectionObjectAdditionalInfo]="
        gridRegistrationDto?.connectionObjectAdditionalInfo
      "></app-connection-object-summary>
  </section>

  <section>
    <app-filiation-data-summary
      [contactData]="gridRegistrationDto?.customer"
      [title]="'Vertragspartner'"></app-filiation-data-summary>
  </section>

  <section *ngIf="gridRegistrationDto?.invoiceContact">
    <app-filiation-data-summary
      [contactData]="gridRegistrationDto?.invoiceContact"
      [title]="'Abweichende Rechnungsanschrift'"></app-filiation-data-summary>
  </section>

  <section *ngIf="gridRegistrationDto?.producers && gridRegistrationDto?.producers.length > 0">
    <app-producers-summary
      [producers]="gridRegistrationDto.producers"
      [consumptionOver30kw]="gridRegistrationDto.consumptionOver30kw"></app-producers-summary>
  </section>

  <section *ngIf="gridRegistrationDto?.consumers && gridRegistrationDto?.consumers.length > 0">
    <app-consumers-summary [consumers]="gridRegistrationDto.consumers"></app-consumers-summary>
  </section>

  <section *ngIf="gridRegistrationDto?.storages && gridRegistrationDto?.storages.length > 0">
    <app-storages-summary [storages]="gridRegistrationDto.storages"></app-storages-summary>
  </section>

  <section *ngIf="gridRegistrationDto?.pvModules && gridRegistrationDto?.pvModules.length > 0">
    <app-pv-modules-summary [pvModules]="gridRegistrationDto.pvModules"></app-pv-modules-summary>
  </section>
</app-default-card>

<app-gr-assign-technician-confirmation-form
  #form
  (onErrorsChanged)="onFormErrorsChanged($event)"></app-gr-assign-technician-confirmation-form>
<app-default-card
  spyTarget="Info"
  [title]="title"
  [info]="''"
  [showChildComponent]="true"
  [showThisComponent]="true">
  <app-form-confirmation
    [actions]="actions"
    [actionConfirm]="'acceptAssignment'"
    [textConfirm]="'Absenden'"
    [actionReject]="null"
    [message]="'Sind Sie sicher, dass Sie sich die Netzanmeldung zuweisen wollen?'"
    [errorFormList]="errorFormList"
    (onActionClickedEvent)="actionToRun($event)"></app-form-confirmation>
</app-default-card>
